import { useTranslation } from 'react-i18next'

import { BulkApproveModal } from '~/pages/SpotBidding/components/BulkApproveModal'
import { BulkApprovePanel } from '~/pages/SpotBidding/components/BulkApprovePanel'
import { useBlockBulkApproval } from '~/pages/SpotBidding/hooks/useBlockBulkApproval'

type Props = Parameters<typeof useBlockBulkApproval>[0]

/**
 * ブロック入札タブのまとめて承認 (AC-BSP-118) の入口・結果・確認モーダル。
 * 通常入札の `SpotBulkApproval` と同じ理由で、 開閉・実行中・結果の state を閉じ込める
 * (ページ本体の state にすると、 開閉のたびにページ全体が描き直され、 数千グループのブロック入札で
 * 確認モーダルを開くまでの時間が伸びる)。
 */
export const BlockBulkApproval = (props: Props): React.ReactElement => {
  const { t } = useTranslation()
  const flow = useBlockBulkApproval(props)
  return (
    <>
      <BulkApprovePanel
        flow={flow}
        hint={
          flow.notApproverCount > 0
            ? t('page:biddingBlock.bulkApprove.entryHintNotApprover', {
                count: flow.notApproverCount,
              })
            : t('page:biddingBlock.bulkApprove.entryHint')
        }
      />
      <BulkApproveModal flow={flow} targetDate={props.targetDate} />
    </>
  )
}
